import axios from "axios";

const baseURL = "https://BdgWarehouseApi.azurewebsites.net/api";
// const baseURL = "http://localhost:3002/api";

const connection = axios.create({
  baseURL: baseURL,
});

connection.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `bearer ${localStorage.getItem("token")}`,
  };
  return config;
});

export default connection;
